/* @flow */
import * as React from 'react';
import { graphql } from 'react-apollo';
import { flatMap } from 'lodash';
import idx from 'idx';

import adminDistrictSchoolAdminsViewQuery from 'admin/queries/adminDistrictSchoolAdminsViewQuery.gql';
import AdminAdminsView from 'admin/components/AdminAdminsView.jsx';
import ErrorReporter from 'app/components/ErrorReporter.jsx';
import LoadingIndicator from 'components/LoadingIndicator.jsx';

type Props = {
  orgId: number,
  data: ReactApolloData<AdminDistrictSchoolAdminsViewQuery>,
};

class AdminDistrictSchoolAdminsView extends React.Component<Props> {
  render() {
    const { data, orgId } = this.props;

    if (data && data.loading) {
      return <LoadingIndicator height={40} size="small" />;
    }

    const district = idx(data, _ => _.organizations[0]);

    if (!district) {
      return (
        <ErrorReporter error="tried to render AdminDistrictSchoolAdminsView without district" />
      );
    }

    const schools = district.childOrganizations;
    const districtAdminUuids = district.admins.filter(Boolean).map(admin => admin.uuid);

    const admins = flatMap(
      schools,
      (school): Array<Object> =>
        school.admins.filter(admin => !districtAdminUuids.includes(admin.uuid)).map(admin => ({
          ...admin,
          organizationName: school.name,
          organizationId: school.id,
        }))
    );
    const organizationsInfo = schools
      .filter(Boolean)
      .map(school => ({ id: school.id, name: school.name }));

    return (
      <div className="AdminDistrictSchoolAdminsView">
        <AdminAdminsView
          admins={admins}
          districtId={orgId}
          organizationType="School"
          organizations={organizationsInfo}
        />
      </div>
    );
  }
}

const withData = graphql(adminDistrictSchoolAdminsViewQuery, {
  options: ({ orgId }) => ({
    variables: {
      organizationId: orgId,
    },
  }),
});

export { AdminDistrictSchoolAdminsView };
export default withData(AdminDistrictSchoolAdminsView);
